import CustomerProfileRoles from './CustomerProfileRoles'

export default CustomerProfileRoles
